export default __webpack_public_path__ + "static/media/115-bank.c0f99ca2.svg";